export type RuntimeEnv = {
  apiBaseUrl?: string;
  apiFeedUrl?: string;
  apiCrmUrl?: string;
  apiWalletUrl?: string;
  apiFtbConsumerUrl?: string;
  apiCasinoUrl?: string;
  keycloakUrl?: string;
  keycloakClientId?: string;
  keycloakRealm?: string;
  sanityThemeUrl?: string;
  sanityProjectId?: string;
  sanityDataset?: string;
  sportsbookClientUrl?: string;
  growthbookApiHost: string;
  growthbookClientKey: string;
  minioUrl?: string;
  muiXLicenseKey?: string;
  openReplayIngestPoint?: string;
  openReplayProjectKey?: string;
  superAdminBullboardUrl?: string;
  superAdminBullboardCrmUrl?: string;
  superAdminFtbBackofficeUrl?: string;
  superAdminRabbitMqUrl?: string;
  superAdminZabbixUrl?: string;
  superAdminLongRunningQueriesZabbixUrl?: string;
};

type RuntimeEnvSource = Pick<
  ImportMetaEnv,
  | 'VITE_API_BASE_URL'
  | 'VITE_API_FEED_URL'
  | 'VITE_API_CRM_URL'
  | 'VITE_API_WALLET_URL'
  | 'VITE_API_FTB_CONSUMER_URL'
  | 'VITE_API_CASINO_URL'
  | 'VITE_KEYCLOAK_URL'
  | 'VITE_KEYCLOAK_CLIENT_ID'
  | 'VITE_KEYCLOAK_REALM'
  | 'VITE_SANITY_THEME_URL'
  | 'VITE_SANITY_PROJECT_ID'
  | 'VITE_SANITY_DATASET'
  | 'VITE_SPORTSBOOK_CLIENT_URL'
  | 'VITE_GROWTHBOOK_API_HOST'
  | 'VITE_GROWTHBOOK_CLIENT_KEY'
  | 'VITE_MINIO_URL'
  | 'VITE_MUI_X_LICENSE_KEY'
  | 'VITE_OPENREPLAY_INGEST_POINT'
  | 'VITE_OPENREPLAY_PROJECT_KEY'
  | 'VITE_SUPER_ADMIN_BULLBOARD_URL'
  | 'VITE_SUPER_ADMIN_BULLBOARD_CRM_URL'
  | 'VITE_SUPER_ADMIN_FTB_BACKOFFICE_URL'
  | 'VITE_SUPER_ADMIN_RABBITMQ_URL'
  | 'VITE_SUPER_ADMIN_ZABBIX_URL'
  | 'VITE_SUPER_ADMIN_LONG_RUNNING_QUERIES_ZABBIX_URL'
>;

export const createRuntimeEnv = (env: RuntimeEnvSource): RuntimeEnv => ({
  apiBaseUrl: env.VITE_API_BASE_URL,
  apiFeedUrl: env.VITE_API_FEED_URL,
  apiFtbConsumerUrl: env.VITE_API_FTB_CONSUMER_URL,
  apiCrmUrl: env.VITE_API_CRM_URL,
  apiWalletUrl: env.VITE_API_WALLET_URL,
  apiCasinoUrl: env.VITE_API_CASINO_URL,
  keycloakUrl: env.VITE_KEYCLOAK_URL,
  keycloakClientId: env.VITE_KEYCLOAK_CLIENT_ID,
  keycloakRealm: env.VITE_KEYCLOAK_REALM,
  sanityThemeUrl: env.VITE_SANITY_THEME_URL,
  sanityProjectId: env.VITE_SANITY_PROJECT_ID,
  sanityDataset: env.VITE_SANITY_DATASET,
  sportsbookClientUrl: env.VITE_SPORTSBOOK_CLIENT_URL,
  growthbookApiHost: env.VITE_GROWTHBOOK_API_HOST ?? '',
  growthbookClientKey: env.VITE_GROWTHBOOK_CLIENT_KEY ?? '',
  minioUrl: env.VITE_MINIO_URL,
  muiXLicenseKey: env.VITE_MUI_X_LICENSE_KEY,
  openReplayIngestPoint: env.VITE_OPENREPLAY_INGEST_POINT,
  openReplayProjectKey: env.VITE_OPENREPLAY_PROJECT_KEY,
  superAdminBullboardUrl: env.VITE_SUPER_ADMIN_BULLBOARD_URL,
  superAdminBullboardCrmUrl: env.VITE_SUPER_ADMIN_BULLBOARD_CRM_URL,
  superAdminFtbBackofficeUrl: env.VITE_SUPER_ADMIN_FTB_BACKOFFICE_URL,
  superAdminRabbitMqUrl: env.VITE_SUPER_ADMIN_RABBITMQ_URL,
  superAdminZabbixUrl: env.VITE_SUPER_ADMIN_ZABBIX_URL,
  superAdminLongRunningQueriesZabbixUrl: env.VITE_SUPER_ADMIN_LONG_RUNNING_QUERIES_ZABBIX_URL,
});

export const runtimeEnv = createRuntimeEnv(import.meta.env);
